(function(){
  function toggleSelectorItem(root = document) {
    const nav = root.querySelector('.menu-mobile__nav');
    if (!nav) return;

    const firstItem = nav.querySelector('.menu-mobile__nav-item'); // primer hijo
    if (!firstItem) return;

    const items = nav.querySelectorAll('.menu-mobile__nav-item');
    if (!items.length) return;

    const lastItem = items[items.length - 1];
    const looksLikeSelector = lastItem.querySelector('.header-selector__dropdown, .header-selector__toggle');
    if (!looksLikeSelector) return;

    const isActive = firstItem.classList.contains('active');

    // En vez de eliminar → ocultar/mostrar
    lastItem.style.display = isActive ? 'none' : '';
  }

  function watchActiveChange(root = document) {
    const nav = root.querySelector('.menu-mobile__nav');
    if (!nav) return;

    const firstItem = nav.querySelector('.menu-mobile__nav-item');
    if (!firstItem) return;

    // Observa cambios de clase en el primer item
    const mo = new MutationObserver(() => toggleSelectorItem(root));
    mo.observe(firstItem, { attributes: true, attributeFilter: ['class'] });

    // Observa cambios de hijos por si el menú se reconstruye
    const moChildren = new MutationObserver(() => toggleSelectorItem(root));
    moChildren.observe(nav, { childList: true, subtree: false });
  }

  // Inicial
  document.addEventListener('DOMContentLoaded', () => {
    toggleSelectorItem(document);
    watchActiveChange(document);
  });

  // Soporte para re-render de secciones en Shopify
  document.addEventListener('shopify:section:load', e => {
    toggleSelectorItem(e.target);
    watchActiveChange(e.target);
  });
  document.addEventListener('shopify:section:select', e => {
    toggleSelectorItem(e.target);
    watchActiveChange(e.target);
  });
})();
